export function useNotificationNavigation(router) {
  function hasNotificationNavigation(msg) {
    if (!msg?.linkType || msg.linkType === 'NONE') return false
    if (msg.linkType === 'APPROVAL') return true
    if (msg.webUrl || msg.webPath) return true
    const linkTypeRoutes = ['ORDER', 'APPROVAL', 'CUSTOMER', 'CONTRACT', 'SCHEDULE', 'TODO', 'FORM']
    return linkTypeRoutes.includes(msg.linkType)
  }

  function buildNotificationNavigationTarget(msg) {
    if (!msg?.linkType || msg.linkType === 'NONE') return null

    const linkTypeRoutes = {
      ORDER: '/order',
      APPROVAL: '/approval',
      CUSTOMER: '/customer',
      CONTRACT: '/contract',
      SCHEDULE: '/schedule',
      TODO: '/todo',
      FORM: '/form'
    }

    const rawPath = msg.linkType === 'APPROVAL' ? linkTypeRoutes.APPROVAL : (msg.webPath || linkTypeRoutes[msg.linkType])
    const { path: basePath, query: pathQuery } = splitPathAndQuery(rawPath)
    if (!basePath) return null

    const query = { ...pathQuery }
    if (msg.businessId) {
      query.id = msg.businessId
    }
    if (msg.linkType === 'APPROVAL' && msg.businessId) {
      Object.assign(query, { openDetail: 'true' })
      if (isReadonlyWorkflowNotification(msg)) {
        Object.assign(query, { readonly: 'true' })
      }
      const approvalTab = getWorkflowApprovalTab(msg)
      if (approvalTab) {
        Object.assign(query, { tab: approvalTab })
      }
    }
    Object.assign(query, parseExtraParams(msg.extraParams))

    return { path: basePath, query }
  }

  function splitPathAndQuery(path) {
    if (!path || typeof path !== 'string') return { path, query: {} }
    const queryIndex = path.indexOf('?')
    if (queryIndex < 0) return { path, query: {} }
    const basePath = path.slice(0, queryIndex)
    return {
      path: basePath || path,
      query: parseQueryString(path.slice(queryIndex + 1))
    }
  }

  function parseExtraParams(extraParams) {
    if (!extraParams) return {}
    if (typeof extraParams === 'object' && !Array.isArray(extraParams)) {
      return extraParams
    }
    if (typeof extraParams !== 'string') return {}
    const trimmed = extraParams.trim()
    if (!trimmed) return {}
    try {
      const parsed = JSON.parse(trimmed)
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed
      }
    } catch {
      return parseQueryString(trimmed)
    }
    return {}
  }

  function parseQueryString(queryString) {
    if (!queryString || typeof queryString !== 'string') return {}
    const query = {}
    new URLSearchParams(queryString).forEach((value, key) => {
      query[key] = value
    })
    return query
  }

  function isReadonlyWorkflowNotification(msg) {
    return ['WORKFLOW_CC', 'WORKFLOW_APPROVAL_RESULT'].includes(msg?.bizType)
  }

  function getWorkflowApprovalTab(msg) {
    const tabRoutes = {
      WORKFLOW_CC: { tab: 'cc' },
      WORKFLOW_APPROVAL_RESULT: { tab: 'initiated' }
    }
    return tabRoutes[msg?.bizType]?.tab
  }

  function navigateNotification(msg) {
    if (!msg?.linkType || msg.linkType === 'NONE') return false

    const target = buildNotificationNavigationTarget(msg)
    if (target) {
      router.push(target)
      return true
    }

    if (msg.webUrl) {
      if (msg.webUrl.startsWith('http://') || msg.webUrl.startsWith('https://')) {
        window.open(msg.webUrl, msg.webNewWindow ? '_blank' : '_self')
      } else {
        router.push(msg.webUrl)
      }
      return true
    }

    return false
  }

  return {
    hasNotificationNavigation,
    buildNotificationNavigationTarget,
    navigateNotification,
    isReadonlyWorkflowNotification,
    getWorkflowApprovalTab
  }
}
